// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drilldown-modal-container {
	margin: 0px auto;
	padding: 0px 40px;
	z-index: 5002;
	position: relative;
	height: 100%;
	overflow: auto;
}

@media (max-width: 768px) {
	.drilldown-modal-container {
		padding: 0px;
	}
}

.drilldown-modal-content {
	background: white;
	height: 100%;
	display: flex;
	flex-direction: column;
}

.drilldown-modal-overlay {
	position: fixed;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	height: 100%;
	background: #000;
	opacity: .7;
	z-index: 5000;
}

.drilldown-modal-header {
	flex: 0 1 auto;
	display: flex;
	flex-direction: row-reverse;
	align-items: center;
	padding: 20px;
	height: 18px;
	background: white;
}

.drilldown-modal-close-button {
	display: inline-block;
	color: #0067B1;
	cursor: pointer;
}

.drilldown-report-frame {
	width: 100%;
	flex: 1 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Dashboard/DrilldownModal.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,aAAa;CACb,kBAAkB;CAClB,YAAY;CACZ,cAAc;AACf;;AAEA;CACC;EACC,YAAY;CACb;AACD;;AAEA;CACC,iBAAiB;CACjB,YAAY;CACZ,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,OAAO;CACP,MAAM;CACN,SAAS;CACT,QAAQ;CACR,YAAY;CACZ,gBAAgB;CAChB,WAAW;CACX,aAAa;AACd;;AAEA;CACC,cAAc;CACd,aAAa;CACb,2BAA2B;CAC3B,mBAAmB;CACnB,aAAa;CACb,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;CACrB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,cAAc;AACf","sourcesContent":[".drilldown-modal-container {\n\tmargin: 0px auto;\n\tpadding: 0px 40px;\n\tz-index: 5002;\n\tposition: relative;\n\theight: 100%;\n\toverflow: auto;\n}\n\n@media (max-width: 768px) {\n\t.drilldown-modal-container {\n\t\tpadding: 0px;\n\t}\n}\n\n.drilldown-modal-content {\n\tbackground: white;\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.drilldown-modal-overlay {\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tbottom: 0;\n\tright: 0;\n\theight: 100%;\n\tbackground: #000;\n\topacity: .7;\n\tz-index: 5000;\n}\n\n.drilldown-modal-header {\n\tflex: 0 1 auto;\n\tdisplay: flex;\n\tflex-direction: row-reverse;\n\talign-items: center;\n\tpadding: 20px;\n\theight: 18px;\n\tbackground: white;\n}\n\n.drilldown-modal-close-button {\n\tdisplay: inline-block;\n\tcolor: #0067B1;\n\tcursor: pointer;\n}\n\n.drilldown-report-frame {\n\twidth: 100%;\n\tflex: 1 0 auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
